import fancybox from '@fancyapps/fancybox'
jQuery(function($) {
    $(document).ready(function() {
        $('[data-fancybox]').fancybox();
    });
});

